import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorFileQuery,
  GetProcessorFileQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSOR_FILE: TypedDocumentNode<
  GetProcessorFileQuery,
  GetProcessorFileQueryVariables
> = gql`
  query GetProcessorFile($id: String!) {
    processorFile(id: $id) {
      id
      code
    }
  }
`;
